<template>
  <div 
    class="d-flex"
    :style="{position: 'relative', width: 'min-content', width: 'min-content'}"
  >
    <v-icon 
      v-bind="{[sizeProp]: sizeProp === 'size' ? size : true}"
      :color="server.textColor || 'white'"
      :style="{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%) scale(0.95)'
      }"
    >
      mdi-checkbox-blank
    </v-icon>
    <v-icon 
      v-bind="{[sizeProp]: sizeProp === 'size' ? size : sizeProp === 'size' ? size : true, color: (server || {}).color || 'grey'}"
      :style="{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
      }"
    >
      {{ `mdi-alpha-${((server || {}).name || 's').toLowerCase()[0]}-box` }}
    </v-icon>
    <v-icon 
      v-bind="{[sizeProp]: sizeProp === 'size' ? size : true}"
      color="transparent"
    >
      mdi-checkbox-blank
    </v-icon>
  </div>
</template>

<script>
const SIZE_PROPS = ['xLarge', 'large', 'dense', 'small', 'xSmall']
export default {
  name: 'ServerInitialIcon',
  props: {
    /**
     * `xLarge`, `large`, `dense`, `small` and `xSmall` props 
     * used to set the size of the server initial icon
     */
    ...SIZE_PROPS.reduce((acc, sp) => {
      acc[sp] = Boolean
      return acc
    }, {}) ?? {},
    size: [String, Number],
    server: Object
  },
  data () {
    return {}
  },
  computed: {
    /** Parses out the first included `size` prop */
    sizeProp () {return this.parseProp(SIZE_PROPS)},
  },
  methods: {
    parseProp (values) {
      for (let value of values) 
        if (this.$props[value]) return value
      return 'size'
    }
  }
}
</script>